
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/suporte",
      function () {
        return require("private-next-pages/home/suporte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/suporte"])
      });
    }
  